import { useEffect, useState } from "react";
import { useParams, useHistory } from "react-router-dom";
import { getNFTDetail } from "../services/api";
import bnbIcon from "../assets/new-ui/bnb-icon.png";
import { formatBalanceDisplay, isMobile } from "../utils/utils";
import Menu from "../components/Menu";
import ScrollTop from "../components/ScrollTop";
import CustomButton from "../components/CustomButton";
import {
  BNB_DECIMAL,
  STATUS_BUY_NOW,
  STATUS_DELISTED,
} from "../constants/config";
import { useAddress } from "../contexts/Context";
import ConnectWallet from "../components/ConnectWallet";
import { buyItem, cancelListItem, listItem } from "../services/smartcontract";
import ModalSellOption from "../components/sellNFT/ModalSellOption";
import ModalSellConfirm from "../components/sellNFT/ModalSellConfirm";
import ModalSellResult from "../components/sellNFT/ModalSellResult";
import ModalCancelListing from "../components/cancelListing/ModalCancelListing";
import ModalCancelListingResult from "../components/cancelListing/ModalCancelListingResult";
import ModalBuyConfirm from "../components/buyNFT/ModalBuyConfirm";
import ModalBuyResult from "../components/buyNFT/ModalBuyResult";
import ModalBuyOption from "../components/buyNFT/ModalBuyOption";
import Bubble from "../components/coral/Bubble";
import CoralRightType2 from "../components/coral/CoralRightType2";

export default function Detail() {
  const { tokenId } = useParams();
  const [item, setItem] = useState(null);
  const history = useHistory();
  const [address] = useAddress();

  const [sellSelectionBox, setSellSelectionBox] = useState(false);
  const [sellConfirmBox, setSellConfirmBox] = useState(false);
  const [sellSuccessfulBox, setSellSuccessfulBox] = useState(false);

  const [cancelListingBox, setCancelListingBox] = useState(false);
  const [cancelListingSuccessfulBox, setCancelListingSuccessfulBox] =
    useState(false);

  const [buyOptionBox, setBuyOptionBox] = useState(false);
  const [buyConfirmBox, setBuyConfirmBox] = useState(false);
  const [buySuccessfulBox, setBuySuccessfulBox] = useState(false);
  const [price, setPrice] = useState(0);
  const [processing, setProcessing] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    getNFTDetail(tokenId).then((result) => {
      // console.log(result)
      if (result.success) {
        // console.log(result.message)
        setItem(result.message);
        // setItem(sharkNFT)
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // useEffect(() => {
  //   if (fee) {
  //     setSellSelectionBox(false)
  //     setSellSuccessfulBox(true)
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // },[fee])

  function handleSellNFT() {
    listItem(address, tokenId, price, false, setProcessing).then((result) => {
      if (result) {
        setProcessing(false);
        setSellConfirmBox(false);
        setSellSuccessfulBox(true);
      }
    });
  }

  function handleCancelListing() {
    cancelListItem(address, tokenId, setProcessing).then((result) => {
      if (result) {
        setProcessing(false);
        setCancelListingBox(false);
        setCancelListingSuccessfulBox(true);
      }
    });
  }

  function handleBuyNow() {
    buyItem(address, tokenId, item.currentPrice, setProcessing).then(
      (result) => {
        if (result) {
          setProcessing(false);
          setBuyConfirmBox(false);
          setBuySuccessfulBox(true);
        }
      }
    );
  }
  return (
    <div className="pageContainer detailContainer">
      <Menu />
      <ScrollTop />
      <ConnectWallet />
      <CoralRightType2 />
      <Bubble top={"200px"} />

      <ModalSellOption
        toggleModal={sellSelectionBox}
        setToggleModal={setSellSelectionBox}
        img={item?.nft.imageUrl}
        id={item?.nft.name}
        setPrice={setPrice}
        price={price}
        fn={() => setSellConfirmBox(true)}
      />

      <ModalSellConfirm
        toggleModal={sellConfirmBox}
        setToggleModal={setSellConfirmBox}
        id={item?.nft.name}
        price={price}
        fn={handleSellNFT}
        processing={processing}
      />

      <ModalSellResult
        toggleModal={sellSuccessfulBox}
        fn={() => {
          history.push("/marketplace-staging");
        }}
      />

      <ModalCancelListing
        toggleModal={cancelListingBox}
        setToggleModal={setCancelListingBox}
        fn={handleCancelListing}
        processing={processing}
      />

      <ModalCancelListingResult
        toggleModal={cancelListingSuccessfulBox}
        fn={() => {
          history.push("/my-nft");
        }}
      />

      <ModalBuyOption
        toggleModal={buyOptionBox}
        setToggleModal={setBuyOptionBox}
        img={item?.nft.imageUrl}
        id={item?.nft.name}
        price={item?.currentPrice / BNB_DECIMAL}
        fn={() => setBuyConfirmBox(true)}
      />

      <ModalBuyConfirm
        toggleModal={buyConfirmBox}
        setToggleModal={setBuyConfirmBox}
        id={item?.nft.name}
        price={item?.currentPrice / BNB_DECIMAL}
        fn={handleBuyNow}
        processing={processing}
      />

      <ModalBuyResult
        toggleModal={buySuccessfulBox}
        fn={() => {
          history.push("/my-nft");
        }}
      />

      <div className="detailTitle">DETAILs</div>
      <div className="detailContent">
        {item ? (
          <div className="itemContent">
            <div className="itemDetailImg">
              <img src={item.nft.imageUrl} alt="nft" />
            </div>
            <div className="itemDetailInfo">
              <div className="itemDetailInfoBG">
                <div
                  className="itemInfoRow"
                  style={{ paddingBottom: "0px", alignItems: "center" }}
                >
                  <div className="nftName">ID: {item.nft.name}</div>
                  {item.status === STATUS_BUY_NOW ? (
                    <div className="nftPrice">
                      <img src={bnbIcon} alt="icon unit" />
                      <div>
                        {formatBalanceDisplay(item.currentPrice / BNB_DECIMAL) +
                          " " +
                          item.currentCurrency}
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
                <div className="itemInfoRow">
                  <div className="nftAssume">
                    <div className="nftInfoTitle">Rarity class</div>
                    <div className="nftInfoValue">{item.nft.rare}</div>
                  </div>
                </div>
                <div className="itemInfoRow">
                  <div className="nftAssume">
                    <div className="nftInfoTitle">Rarity point</div>
                    <div className="nftInfoValue">{item.nft.point}</div>
                  </div>
                </div>
                {!isMobile() &&
                  item.nft.items.map((part, index) => {
                    if (index % 2 === 0) {
                      return (
                        <div className="itemInfoRow" key={index}>
                          <div className="nftBodyGroup">
                            <div className="nftBodyPart">
                              <div className="nftInfoTitle">
                                {item.nft.items[index].type}
                              </div>
                              <div className="nftInfoValueGroup">
                                <div>{item.nft.items[index].rarity}</div>
                                <div>{item.nft.items[index].chance + " %"}</div>
                              </div>
                            </div>

                            <div className="nftBodyPart">
                              <div className="nftInfoTitle">
                                {item.nft.items[index + 1].type}
                              </div>
                              <div className="nftInfoValueGroup">
                                <div>{item.nft.items[index + 1].rarity}</div>
                                <div>
                                  {item.nft.items[index + 1].chance + " %"}
                                </div>
                              </div>
                            </div>

                            {/* <div className='nftBodyPart'>
                                  <div className='nftInfoTitle'>{item.nft.items[index + 2].type}</div>
                                  <div className='nftInfoValueGroup'>
                                    <div>{item.nft.items[index + 2].rarity}</div>
                                    <div>{item.nft.items[index + 2].chance + ' %'}</div>
                                  </div>
                                </div> */}
                          </div>
                        </div>
                      );
                    } else return "";
                  })}

                {isMobile() &&
                  item.nft.items.map((part, index) => {
                    if (index % 2 === 0 && index < 12) {
                      return (
                        <div className="itemInfoRow" key={index}>
                          <div className="nftBodyGroup">
                            <div className="nftBodyPart">
                              <div className="nftInfoTitle">
                                {item.nft.items[index].type}
                              </div>
                              <div className="nftInfoValueGroup">
                                <div>{item.nft.items[index].rarity}</div>
                                <div>{item.nft.items[index].chance + " %"}</div>
                              </div>
                            </div>

                            <div className="nftBodyPart">
                              <div className="nftInfoTitle">
                                {item.nft.items[index + 1].type}
                              </div>
                              <div className="nftInfoValueGroup">
                                <div>{item.nft.items[index + 1].rarity}</div>
                                <div>
                                  {item.nft.items[index + 1].chance + " %"}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    } else return null;
                  })}
              </div>

              {/* Owner and NFT are listing */}
              {address === item.currentOwner &&
                item.status === STATUS_DELISTED && (
                  <div className="groupBtn">
                    <CustomButton
                      text={"SELL YOUR NFTs"}
                      textColor={"black"}
                      fn={() => setSellSelectionBox(true)}
                      type={"medium"}
                      transparent={false}
                    />
                    <CustomButton
                      text={"BACK"}
                      textColor={"black"}
                      fn={() => history.goBack()}
                      transparent={true}
                    />
                  </div>
                )}

              {/* Owner and NFT is not list */}
              {address === item.currentOwner &&
                item.status !== STATUS_DELISTED && (
                  <div className="groupBtn">
                    <CustomButton
                      text={"CANCEL LISTING"}
                      textColor={"black"}
                      fn={() => setCancelListingBox(true)}
                      type={"medium"}
                      transparent={false}
                    />
                    <CustomButton
                      text={"BACK"}
                      textColor={"black"}
                      fn={() => history.goBack()}
                      transparent={true}
                    />
                  </div>
                )}

              {/* Visitor and NFT is listing */}
              {address !== item.currentOwner &&
                item.status !== STATUS_DELISTED && (
                  <div className="groupBtn">
                    <CustomButton
                      text={"BUY NOW"}
                      textColor={"black"}
                      fn={() => setBuyOptionBox(true)}
                      type={"medium"}
                      transparent={false}
                    />
                    <CustomButton
                      text={"BACK"}
                      textColor={"black"}
                      fn={() => history.goBack()}
                      transparent={true}
                    />
                  </div>
                )}
            </div>
          </div>
        ) : (
          ""
        )}
      </div>
      <div className="footer">
        <Bubble bottom={"5%"} />
        <div className="footerBrand">@Sharktopia 2021</div>
      </div>
    </div>
  );
}
